import { UserRole } from '../types';

/**
 * Converts a UserRole enum value to a user-friendly display format
 * @param role The UserRole enum value
 * @returns A formatted string representation of the role
 */
export const getRoleLabel = (role: UserRole): string => {
  switch (role) {
    case UserRole.ADMINISTRATOR:
      return 'Administrator';
    case UserRole.SUPERVISOR:
      return 'Supervisor';
    case UserRole.CSR:
      return 'CSR';
    case UserRole.DEALER:
      return 'Dealer';
    default:
      return role;
  }
};

/**
 * Converts a boolean status value to a user-friendly display format
 * @param status The status of the user, active/inactive true/false.
 * @returns A formatted string representation of the status
 */
export const getStatusLabel = (status: boolean): string => {
  if (status) {
    return 'Active';
  }

  return 'Inactive';
};
